import React from 'react';
interface IconProps {
  className?: string;
}

// Padel court viewed from above: outer rectangle, center net line, service lines.
export function MapaDePistaIcon({
  className = ''
}: IconProps) {
  return <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true" data-id="element-324" data-mp="u3qgcrczdlz7">
      <rect x="6" y="8" width="36" height="32" rx="2" data-id="element-325" data-mp="1ms4j1kf0l6h3" />
      <line x1="6" y1="24" x2="42" y2="24" strokeWidth="2.2" data-id="element-326" data-mp="1rqfpdl63oyuk" />
      <line x1="24" y1="8" x2="24" y2="40" strokeDasharray="1 4" data-id="element-327" data-mp="1rss6xx7y5773" />
      <line x1="6" y1="16" x2="42" y2="16" strokeDasharray="1 4" data-id="element-328" data-mp="1d1042kpc9lm9" />
      <line x1="6" y1="32" x2="42" y2="32" strokeDasharray="1 4" data-id="element-329" data-mp="1i0me6l9velqu" />
    </svg>;
}

// Annual calendar grid: 12 small cells representing the 12 months.
export function Programador12MesesIcon({
  className = ''
}: IconProps) {
  return <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true" data-id="element-330" data-mp="2ahysrt41eex4">
      <rect x="6" y="10" width="36" height="30" rx="2" data-id="element-331" data-mp="3cb1ynv5y0e5a" />
      <line x1="6" y1="17" x2="42" y2="17" data-id="element-332" data-mp="3q0vn4cdjcweh" />
      <line x1="16" y1="6" x2="16" y2="13" data-id="element-333" data-mp="3q2qadxca50lq" />
      <line x1="32" y1="6" x2="32" y2="13" data-id="element-334" data-mp="3l9dmjpffcxu1" />
      {[0, 1, 2].map(row => [0, 1, 2, 3].map(col => <rect key={`${row}-${col}`} x={11 + col * 7.2} y={21 + row * 6} width="4.4" height="3.6" rx="0.6" strokeWidth="1.2" data-id="element-335" data-mp="3sckzu7l8i0u" />))}
    </svg>;
}